import { IntegrationTypes } from '@prisma/client';
import { IntegrationReportData } from '@zond/api-interfaces';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ClickUpIntegrationCard } from './clickup-integration-card';
import { GitHubIntegrationCard } from './github-integration-card';
import { JiraIntegrationCard } from './jira-integration-card';
import { LinearIntegrationCard } from './linear-integration-card';

interface IntegrationCardsGridProps {
  integrations?: IntegrationReportData[];
  isLoading: boolean;
}

export const IntegrationCardsGrid: React.FC<IntegrationCardsGridProps> = ({ integrations, isLoading }) => {
  const { t } = useTranslation('reports');
  return (
    <div className="bg-card rounded-lg shadow border mb-6">
      <div className="p-6">
        <div className="space-y-1.5 mb-4">
          <h2 className="text-2xl font-semibold leading-none tracking-tight">{t('integration.title')}</h2>
        </div>
        {isLoading ? (
          <div className="space-y-4">
            {[1, 2].map((i) => (
              <div key={i} className="p-4 bg-muted rounded animate-pulse">
                <div className="h-6 bg-muted-foreground/20 rounded w-1/3 mb-3"></div>
                <div className="space-y-2">
                  {[1, 2, 3].map((j) => (
                    <div key={j} className="h-8 bg-muted-foreground/20 rounded"></div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : !integrations || integrations.length === 0 ? (
          <div className="p-6 bg-muted/50 rounded text-center text-sm text-muted-foreground">
            {t('integration.emptyPeriod')}
          </div>
        ) : (
          <div className="space-y-4">
            {integrations.map((integration) => {
              switch (integration.integrationType) {
                case IntegrationTypes.GitHub:
                  return <GitHubIntegrationCard key={integration.integrationType} data={integration} />;
                case IntegrationTypes.Jira:
                  return <JiraIntegrationCard key={integration.integrationType} data={integration} />;
                case IntegrationTypes.Linear:
                  return <LinearIntegrationCard key={integration.integrationType} data={integration} />;
                case IntegrationTypes.ClickUp:
                  return <ClickUpIntegrationCard key={integration.integrationType} data={integration} />;
                default:
                  return null;
              }
            })}
          </div>
        )}
      </div>
    </div>
  );
};
